import {Box, Skeleton} from '@mui/material';

import {EmpionPaper} from '../../../../../components/EmpionPaper/EmpionPaper';

export const DepartmentSelectorBarSkeleton = () => {
  return (
    <EmpionPaper
      sx={{
        border: '0.5px solid',
        borderColor: 'divider',
        borderRadius: '12px',
        px: 2.5,
        py: 2.25,
        mb: 1,
      }}
    >
      <Skeleton variant='text' width={80} height={14} sx={{mb: 1.25}} />
      <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 1}}>
        {Array.from({length: 4}).map((_, index) => (
          <Skeleton key={index} variant='rounded' width={110} height={34} sx={{borderRadius: '8px'}} />
        ))}
      </Box>
    </EmpionPaper>
  );
};
